import React from 'react';

const OurHistory = () => {
  return (
    <div>
      <h1>History</h1>
      <img src="/icebergers-history.jpg" alt="The annual Olsen & Hooper swim" />
      <p>
        The annual Olsen & Hooper swim requires ‘traditional’ swim costumes and
        knowledge of how to bride the handicapper.
      </p>
      <p>
        In the 1980's when John Locco, the prime mover in the preservation of the
        Middle Brighton Baths and environs began swimming around the Brighton
        pier with his great mate Robert Hooper, little did he envisage how the
        number of swimmers would grow, events multiply and sorties undertaken to
        compete in ocean swims around Australia and the Globe.
      </p>
      <p>
        Brighton Icebergers have swum all over Australia, San Francisco, (annual
        Alcatraz Swim), across to New Zealand's Lake Taupo, Lake Zurich, English
        Channel and even conquered the challenging and treacherous rip swim
        across the entrance to Port Phillip Bay.
      </p>
      <p>
        The Brighton Icebergers, with much history behind them, have access to
        two great facilities for year round swimming.
      </p>
      <p>
        For those who enjoy the shorter distances and questionable security of
        an enclosed steel fence ( stingrays and occasional jelly fish still gate
        crash) there is the historic Middle Brighton Sea Baths. Jutting out into
        the bay for approx 100m and 50m wide the original structure opened in
        1881 .Storm, sea damage and age saw it undergo three major restorations
        the first in 1934 following a violent storm, the second in 1986 to
        restore the ageing structure and the last being in 2001 when a major
        upgrade saw significant modernisation which added two restaurants, a
        steam room and gym.
      </p>
      <p>
        The second and larger contingent of Icebergers, whose passion is open
        water swimming, has its base 100m away at the Royal Brighton Yacht Club
        (RBYC) located adjacent to the Baths.
      </p>
      <p>
        Established in 1875, the RBYC is the home of Australia’s first Americas
        Cup Challenge. The yacht was “Gretel”, funded by Sir Frank Packer and
        the skipper was RBYC yachtsman Jock Sturrock. Australia didn’t win on
        that occasion in 1962 but we gave notice we were in play. Another
        attempt followed in 1967 with “Dame Pattie” and in 1983 John Bertrand, a
        skipper with strong Brighton connections, took the olde mug from the USA
        off Newport Rhode Island with the revolutionary wing keeled “Australia 2
        ” and as they say the rest is history.
      </p>
      <p>
        In Summer 2006, the Yacht club completed a multi million dollar
        renovation which added excellent gym space, steam and sauna rooms, new
        bars as well as restaurant & café destinations. Icebergers who swim out
        of RBYC – cover a series of year round open water courses ranging from
        “Morning Glory” over 250m, “No Brainer” over 1.5km and the’ Big Course
        “out to the Reef Marker is over 2km. Teabags are occasionally spotted –
        one quick dip and out – but essentially those who swim here like
        distance and open water swimming.
      </p>
      <p>
        An interloper Kiwi in the Club, Paul Percy, along with Aussie Legend
        John Olson has also introduced the ANZAC course which stretches the
        distance (and swimmers) via marker buoys to 5.4km.
      </p>
      <p>
        Open Water swimming is never routine. Every day brings different sea
        conditions at Brighton - swells, currents, chop and winds. The power of
        nature is respected. Regularly joining the Icebergers on their swims are
        some resident penguins, bottle nosed dolphins and an elderly stingray
        who lives along the route of one of the swim courses.
      </p>
      <p>
        The Brighton Icebergers welcome swimmers, it has an active group
        of over two hundred swimmers.  Only fully committed winter swimmers should apply for membership.
      </p>
      <p>© Brighton Icebergers @ RBYC</p>
    </div>
  );
};

export default OurHistory;
